import { render, staticRenderFns } from "./NotificationsSetup.vue?vue&type=template&id=57b33c37&scoped=true"
import script from "./NotificationsSetup.vue?vue&type=script&lang=ts"
export * from "./NotificationsSetup.vue?vue&type=script&lang=ts"
import style0 from "./NotificationsSetup.vue?vue&type=style&index=0&id=57b33c37&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57b33c37",
  null
  
)

export default component.exports